export default __webpack_public_path__ + "static/media/minus9-1.eea9187d.png";